export { default as F } from "./F.js";
export { default as T } from "./T.js";
export { default as __ } from "./__.js";
export { default as add } from "./add.js";
export { default as addIndex } from "./addIndex.js";
export { default as adjust } from "./adjust.js";
export { default as all } from "./all.js";
export { default as allPass } from "./allPass.js";
export { default as always } from "./always.js";
export { default as and } from "./and.js";
export { default as any } from "./any.js";
export { default as anyPass } from "./anyPass.js";
export { default as ap } from "./ap.js";
export { default as aperture } from "./aperture.js";
export { default as append } from "./append.js";
export { default as apply } from "./apply.js";
export { default as applySpec } from "./applySpec.js";
export { default as applyTo } from "./applyTo.js";
export { default as ascend } from "./ascend.js";
export { default as assoc } from "./assoc.js";
export { default as assocPath } from "./assocPath.js";
export { default as binary } from "./binary.js";
export { default as bind } from "./bind.js";
export { default as both } from "./both.js";
export { default as call } from "./call.js";
export { default as chain } from "./chain.js";
export { default as clamp } from "./clamp.js";
export { default as clone } from "./clone.js";
export { default as comparator } from "./comparator.js";
export { default as complement } from "./complement.js";
export { default as compose } from "./compose.js";
export { default as composeK } from "./composeK.js";
export { default as composeP } from "./composeP.js";
export { default as composeWith } from "./composeWith.js";
export { default as concat } from "./concat.js";
export { default as cond } from "./cond.js";
export { default as construct } from "./construct.js";
export { default as constructN } from "./constructN.js";
export { default as contains } from "./contains.js";
export { default as converge } from "./converge.js";
export { default as countBy } from "./countBy.js";
export { default as curry } from "./curry.js";
export { default as curryN } from "./curryN.js";
export { default as dec } from "./dec.js";
export { default as defaultTo } from "./defaultTo.js";
export { default as descend } from "./descend.js";
export { default as difference } from "./difference.js";
export { default as differenceWith } from "./differenceWith.js";
export { default as dissoc } from "./dissoc.js";
export { default as dissocPath } from "./dissocPath.js";
export { default as divide } from "./divide.js";
export { default as drop } from "./drop.js";
export { default as dropLast } from "./dropLast.js";
export { default as dropLastWhile } from "./dropLastWhile.js";
export { default as dropRepeats } from "./dropRepeats.js";
export { default as dropRepeatsWith } from "./dropRepeatsWith.js";
export { default as dropWhile } from "./dropWhile.js";
export { default as either } from "./either.js";
export { default as empty } from "./empty.js";
export { default as endsWith } from "./endsWith.js";
export { default as eqBy } from "./eqBy.js";
export { default as eqProps } from "./eqProps.js";
export { default as equals } from "./equals.js";
export { default as evolve } from "./evolve.js";
export { default as filter } from "./filter.js";
export { default as find } from "./find.js";
export { default as findIndex } from "./findIndex.js";
export { default as findLast } from "./findLast.js";
export { default as findLastIndex } from "./findLastIndex.js";
export { default as flatten } from "./flatten.js";
export { default as flip } from "./flip.js";
export { default as forEach } from "./forEach.js";
export { default as forEachObjIndexed } from "./forEachObjIndexed.js";
export { default as fromPairs } from "./fromPairs.js";
export { default as groupBy } from "./groupBy.js";
export { default as groupWith } from "./groupWith.js";
export { default as gt } from "./gt.js";
export { default as gte } from "./gte.js";
export { default as has } from "./has.js";
export { default as hasIn } from "./hasIn.js";
export { default as hasPath } from "./hasPath.js";
export { default as head } from "./head.js";
export { default as identical } from "./identical.js";
export { default as identity } from "./identity.js";
export { default as ifElse } from "./ifElse.js";
export { default as inc } from "./inc.js";
export { default as includes } from "./includes.js";
export { default as indexBy } from "./indexBy.js";
export { default as indexOf } from "./indexOf.js";
export { default as init } from "./init.js";
export { default as innerJoin } from "./innerJoin.js";
export { default as insert } from "./insert.js";
export { default as insertAll } from "./insertAll.js";
export { default as intersection } from "./intersection.js";
export { default as intersperse } from "./intersperse.js";
export { default as into } from "./into.js";
export { default as invert } from "./invert.js";
export { default as invertObj } from "./invertObj.js";
export { default as invoker } from "./invoker.js";
export { default as is } from "./is.js";
export { default as isEmpty } from "./isEmpty.js";
export { default as isNil } from "./isNil.js";
export { default as join } from "./join.js";
export { default as juxt } from "./juxt.js";
export { default as keys } from "./keys.js";
export { default as keysIn } from "./keysIn.js";
export { default as last } from "./last.js";
export { default as lastIndexOf } from "./lastIndexOf.js";
export { default as length } from "./length.js";
export { default as lens } from "./lens.js";
export { default as lensIndex } from "./lensIndex.js";
export { default as lensPath } from "./lensPath.js";
export { default as lensProp } from "./lensProp.js";
export { default as lift } from "./lift.js";
export { default as liftN } from "./liftN.js";
export { default as lt } from "./lt.js";
export { default as lte } from "./lte.js";
export { default as map } from "./map.js";
export { default as mapAccum } from "./mapAccum.js";
export { default as mapAccumRight } from "./mapAccumRight.js";
export { default as mapObjIndexed } from "./mapObjIndexed.js";
export { default as match } from "./match.js";
export { default as mathMod } from "./mathMod.js";
export { default as max } from "./max.js";
export { default as maxBy } from "./maxBy.js";
export { default as mean } from "./mean.js";
export { default as median } from "./median.js";
export { default as memoizeWith } from "./memoizeWith.js";
export { default as merge } from "./merge.js";
export { default as mergeAll } from "./mergeAll.js";
export { default as mergeDeepLeft } from "./mergeDeepLeft.js";
export { default as mergeDeepRight } from "./mergeDeepRight.js";
export { default as mergeDeepWith } from "./mergeDeepWith.js";
export { default as mergeDeepWithKey } from "./mergeDeepWithKey.js";
export { default as mergeLeft } from "./mergeLeft.js";
export { default as mergeRight } from "./mergeRight.js";
export { default as mergeWith } from "./mergeWith.js";
export { default as mergeWithKey } from "./mergeWithKey.js";
export { default as min } from "./min.js";
export { default as minBy } from "./minBy.js";
export { default as modulo } from "./modulo.js";
export { default as move } from "./move.js";
export { default as multiply } from "./multiply.js";
export { default as nAry } from "./nAry.js";
export { default as negate } from "./negate.js";
export { default as none } from "./none.js";
export { default as not } from "./not.js";
export { default as nth } from "./nth.js";
export { default as nthArg } from "./nthArg.js";
export { default as o } from "./o.js";
export { default as objOf } from "./objOf.js";
export { default as of } from "./of.js";
export { default as omit } from "./omit.js";
export { default as once } from "./once.js";
export { default as or } from "./or.js";
export { default as otherwise } from "./otherwise.js";
export { default as over } from "./over.js";
export { default as pair } from "./pair.js";
export { default as partial } from "./partial.js";
export { default as partialRight } from "./partialRight.js";
export { default as partition } from "./partition.js";
export { default as path } from "./path.js";
export { default as paths } from "./paths.js";
export { default as pathEq } from "./pathEq.js";
export { default as pathOr } from "./pathOr.js";
export { default as pathSatisfies } from "./pathSatisfies.js";
export { default as pick } from "./pick.js";
export { default as pickAll } from "./pickAll.js";
export { default as pickBy } from "./pickBy.js";
export { default as pipe } from "./pipe.js";
export { default as pipeK } from "./pipeK.js";
export { default as pipeP } from "./pipeP.js";
export { default as pipeWith } from "./pipeWith.js";
export { default as pluck } from "./pluck.js";
export { default as prepend } from "./prepend.js";
export { default as product } from "./product.js";
export { default as project } from "./project.js";
export { default as prop } from "./prop.js";
export { default as propEq } from "./propEq.js";
export { default as propIs } from "./propIs.js";
export { default as propOr } from "./propOr.js";
export { default as propSatisfies } from "./propSatisfies.js";
export { default as props } from "./props.js";
export { default as range } from "./range.js";
export { default as reduce } from "./reduce.js";
export { default as reduceBy } from "./reduceBy.js";
export { default as reduceRight } from "./reduceRight.js";
export { default as reduceWhile } from "./reduceWhile.js";
export { default as reduced } from "./reduced.js";
export { default as reject } from "./reject.js";
export { default as remove } from "./remove.js";
export { default as repeat } from "./repeat.js";
export { default as replace } from "./replace.js";
export { default as reverse } from "./reverse.js";
export { default as scan } from "./scan.js";
export { default as sequence } from "./sequence.js";
export { default as set } from "./set.js";
export { default as slice } from "./slice.js";
export { default as sort } from "./sort.js";
export { default as sortBy } from "./sortBy.js";
export { default as sortWith } from "./sortWith.js";
export { default as split } from "./split.js";
export { default as splitAt } from "./splitAt.js";
export { default as splitEvery } from "./splitEvery.js";
export { default as splitWhen } from "./splitWhen.js";
export { default as startsWith } from "./startsWith.js";
export { default as subtract } from "./subtract.js";
export { default as sum } from "./sum.js";
export { default as symmetricDifference } from "./symmetricDifference.js";
export { default as symmetricDifferenceWith } from "./symmetricDifferenceWith.js";
export { default as tail } from "./tail.js";
export { default as take } from "./take.js";
export { default as takeLast } from "./takeLast.js";
export { default as takeLastWhile } from "./takeLastWhile.js";
export { default as takeWhile } from "./takeWhile.js";
export { default as tap } from "./tap.js";
export { default as test } from "./test.js";
export { default as andThen } from "./andThen.js";
export { default as times } from "./times.js";
export { default as toLower } from "./toLower.js";
export { default as toPairs } from "./toPairs.js";
export { default as toPairsIn } from "./toPairsIn.js";
export { default as toString } from "./toString.js";
export { default as toUpper } from "./toUpper.js";
export { default as transduce } from "./transduce.js";
export { default as transpose } from "./transpose.js";
export { default as traverse } from "./traverse.js";
export { default as trim } from "./trim.js";
export { default as tryCatch } from "./tryCatch.js";
export { default as type } from "./type.js";
export { default as unapply } from "./unapply.js";
export { default as unary } from "./unary.js";
export { default as uncurryN } from "./uncurryN.js";
export { default as unfold } from "./unfold.js";
export { default as union } from "./union.js";
export { default as unionWith } from "./unionWith.js";
export { default as uniq } from "./uniq.js";
export { default as uniqBy } from "./uniqBy.js";
export { default as uniqWith } from "./uniqWith.js";
export { default as unless } from "./unless.js";
export { default as unnest } from "./unnest.js";
export { default as until } from "./until.js";
export { default as update } from "./update.js";
export { default as useWith } from "./useWith.js";
export { default as values } from "./values.js";
export { default as valuesIn } from "./valuesIn.js";
export { default as view } from "./view.js";
export { default as when } from "./when.js";
export { default as where } from "./where.js";
export { default as whereEq } from "./whereEq.js";
export { default as without } from "./without.js";
export { default as xor } from "./xor.js";
export { default as xprod } from "./xprod.js";
export { default as zip } from "./zip.js";
export { default as zipObj } from "./zipObj.js";
export { default as zipWith } from "./zipWith.js";
export { default as thunkify } from "./thunkify.js";


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/index.js
// module id = 226
// module chunks = 1